import { bootstrapApplication } from '@angular/platform-browser';
import { config } from './app/config';
import { App } from './app/app';
import dayjs from 'dayjs/esm';
import localizedFormat from 'dayjs/esm/plugin/localizedFormat'
dayjs.extend(localizedFormat)

bootstrapApplication(App, config)
  .catch((err) => console.error(err));
